// ============================================================
// BOOKING STATS CARDS COMPONENT
// ============================================================

import { CheckCircle2, Clock, Wallet, XCircle } from 'lucide-react';
import { BookingStats } from '../../hooks/useBookingStats';
import { KPIWidget } from '../shared/KPIWidget';

interface BookingStatsCardsProps {
  stats: BookingStats;
}

export function BookingStatsCards({ stats }: BookingStatsCardsProps) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
      <KPIWidget
        title="Réservations totales"
        value={String(stats.total)}
        subtext="Toutes périodes"
        trend="up"
        color="primary"
        icon={<Wallet />}
      />
      <KPIWidget
        title="En attente d'acceptation"
        value={String(stats.pending)}
        subtext="À traiter"
        trend="down"
        color="warning"
        icon={<Clock />}
      />
      <KPIWidget
        title="Confirmées"
        value={String(stats.confirmed)}
        subtext="Prises en charge"
        trend="up"
        color="secondary"
        icon={<CheckCircle2 />}
      />
      <KPIWidget
        title="Payées"
        value={String(stats.paid)}
        subtext="Réglées"
        trend="up"
        color="success"
        icon={<CheckCircle2 />}
      />
      <KPIWidget
        title="Refusées"
        value={String(stats.rejected)}
        subtext="Rejetées"
        trend="neutral"
        color="error"
        icon={<XCircle />}
      />
    </div>
  );
}
